import { faSearchPlus, faSearchMinus } from '@fortawesome/free-solid-svg-icons';
import { faBrackets } from '@fortawesome/pro-regular-svg-icons';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import SvgIconButton from '../../../common/SvgIconButton';
import usePage from '../../../../hooks/use-page';

const ZoomControls: React.FC = () => {
  const [{ zoomed }, { setPageZoom }] = usePage();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SvgIconButton
        className={classes.zoomBtn}
        iconProps={{ icon: faSearchPlus, size: 'lg' }}
        // disabled={zoomed}
        ariaLabel={tA11y('buttons.zoomIn')}
        onClick={() => setPageZoom(true)}
      />
      <SvgIconButton
        className={classes.zoomBtn}
        disabled={!zoomed}
        iconProps={{ icon: faSearchMinus, size: 'lg' }}
        ariaLabel={tA11y('buttons.zoomOut')}
        onClick={() => setPageZoom(false)}
      />
      <SvgIconButton
        className={classes.zoomBtn}
        disabled={false}
        iconProps={{ icon: faBrackets, size: 'lg' }}
        ariaLabel={tA11y('buttons.fitToPage')}
        onClick={() => setPageZoom(false)}
      />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    gridGap: '1rem',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  zoomBtn: {
    width: '2.5rem',
    height: '2.5rem',
    minWidth: '2.5rem',
    border: 'none',
    boxShadow: '3px 3px 3px grey',
    background: theme.palette.primary.contrastText,
    borderRadius: '5px',
  },
}));

export default ZoomControls;
